import React, { FC, useState } from "react";
import { useForm } from 'react-hook-form';

export type RegTypeFormData = {
  attendee: string,
  payment: string
};


type IRegTypeModalProps = {
  showModal: boolean,
  onSubmit: (formData: RegTypeFormData) => void,  
  onClose: () => void
};

const RegTypeModal: FC<IRegTypeModalProps> = ({showModal, onSubmit, onClose}) => {
  const {register, handleSubmit, setValue} = useForm<RegTypeFormData>();
  
  // evt handlers
  const onFormSubmit = (formData: RegTypeFormData) => {
    const isNotEmpty = Object.values(formData).every(value => value !== undefined && value !== '');
    if (!isNotEmpty || !formData.attendee || !formData.payment) {
      return console.log('Error, empty fields!', formData);
    }
    onSubmit(formData);
  };  
    
  return (
    <React.Fragment>      
      {showModal ? (
        <React.Fragment>
          <div
              className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
              <div className="relative w-auto max-w-sm mx-auto my-6">
                  {/*content*/}
                  <div
                      className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                      {/*header*/}
                      <div
                          className="flex items-start justify-between p-5 border-b border-solid rounded-t border-slate-200">
                          <h3 className="text-3xl font-semibold">
                              Before we begin...
                          </h3>
                          <button
                              className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                              onClick={()=> onClose()}
                              >
                              <span
                                  className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                                  ×
                              </span>
                          </button>
                      </div>
                      {/*body*/}
                      <div className="relative flex-auto p-6">
                          <p className="mt-1 text-lg leading-relaxed text-slate-500">
                              Before we continue, Please select the following questions
                          </p>
                      </div>
                      {/*footer*/}
                      <form
                          onSubmit={handleSubmit(onFormSubmit)}
                          className="flex flex-col items-center justify-between p-6 border-t border-solid rounded-b border-slate-200">
                          <label htmlFor="selfOther" className="block mt-1 mb-2 text-lg leading-relaxed text-slate-500">Who are your registering for?</label>
                          <select
                            {...register('attendee')}
                            id="selfOther" 
                            className="block w-full px-4 py-3 my-4 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white">
                            <option value="self">For Myself</option>
                            <option value="other">For Another attendee</option>                            
                          </select>
                          <label htmlFor="paymentMode" className="block mt-1 mb-2 text-lg leading-relaxed text-slate-500">Mode of payment?</label>
                          <select
                            {...register('payment')} 
                            id="paymentMode" 
                            className="block w-full px-4 py-3 my-4 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white">
                            <option value="online">I will pay online</option>
                            <option value="offline">I will pay cash / have the Team contact me</option>                            
                          </select>
                          <button
                              className="px-6 py-3 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear border-b-4 rounded shadow outline-none bg-emerald-500 hover:bg-emerald-400 active:bg-emerald-600 active:border-emerald-800 border-emerald-700 hover:border-emerald-500 hover:shadow-lg focus:outline-none"
                              type="submit">
                              Continue
                          </button>
                      </form>
                  </div>
              </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default RegTypeModal;